/**
 * System Notifications feature auto-registration and exports
 *
 * This module automatically registers the system notifications feature when imported,
 * making it work seamlessly with both static and dynamic imports.
 */

import { autoRegisterFeature } from '@store/features/factory';

import { systemNotificationsFeature } from './store/feature';

// Auto-register the feature when this module is imported
autoRegisterFeature(systemNotificationsFeature);

// Export store (all store-related exports)
export * from './store';

// Export components
export * from './components';

// Export hooks
export * from './hooks';

// Export types
export * from './types';

// Export constants
export * from './constants';
